

import { createSlice, nanoid } from "@reduxjs/toolkit";

const initialState = {

    route: [
            {
                id: nanoid(),
                searchText: "",
                location: null,
                locationOptions: [],
                lat: "",
                lng: ""
            },
            {
                id: nanoid(),
                searchText: "",
                location: null,
                locationOptions: [],
                lat: "",
                lng: ""
            },
        ],

    kmData: null
}


const kmCalcSlice = createSlice({
    name: "kmCalc",
    initialState,
    reducers: {


        //! yen bir routePoint ekleme 
        addRoutePoint: (state) => {
            state.route = [...state.route,{
                id: nanoid(),
                searchText: "",
                location: null,
                locationOptions: [],
                lat: "",
                lng: ""
            }]
        },

        updateRoutePoint: (state,action) => {
            
            state.route = state.route.map(item => {
                if(item.id === action.payload.id){
                    return {...item, ...action.payload}
                }
                else{
                    return item
                }
            })
        },

        //! km datayı güncelleme
        setKmDataForKmHesaplama: (state ,action) => {
            state.kmData = action.payload
        },


        deleteRouteItem: (state, action) => {
            state.route = state.route.filter((item) => {
                return item.id !== action.payload
            })
        },

        updateAllRoute: (state, action) => {
            state.route = action.payload
        },


        clearRouteItemLocation: (state, action) => {
            state.route = state.route.map((item) => {
                if(item.id === action.payload){
                    return {
                        ...item,
                        searchText: "",
                    }
                }
                else{
                    return item
                }
                    
            })
        },

        resetKmState: (state) => {
            state.route = [
                {
                    id: nanoid(),
                    searchText: "",
                    location: null,
                    locationOptions: [],
                    lat: "",
                    lng: ""
                },
                {
                    id: nanoid(),
                    searchText: "",
                    location: null,
                    locationOptions: [],
                    lat: "",
                    lng: ""
                },
            ]
            state.kmData = null
        }
    },
})


export const {
    addRoutePoint,
    updateRoutePoint,
    setKmDataForKmHesaplama,
    deleteRouteItem,
    updateAllRoute,
    clearRouteItemLocation,
    resetKmState
} = kmCalcSlice.actions
export default kmCalcSlice.reducer